import { httpRequest } from "../../../utils/HttpRequest";
import { IFriendshipDetail } from "./friendshipTypes";
import { IPage } from "@/types/AppTypes";

class FriendshipService {
    async page(searchVo: IFriendshipDetail) {
        const apiUrl = "/web/blogroll/search_page";
        return await httpRequest.post<IPage<IFriendshipDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/web/blogroll/search_one/${id}`;
        return await httpRequest.get<IFriendshipDetail>(apiUrl);
    }
    async insert(insertVo: IFriendshipDetail) {
        const apiUrl = `/web/blogroll/insert`;
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IFriendshipDetail) {
        const apiUrl = `/web/blogroll/update`;
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async delete(id: string) {
        const apiUrl = `/web/blogroll/delete/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
}
export const friendshipService = new FriendshipService();
